export const CREATE_TAG = 'CREATE_TAG';
export const FETCH_COMPANY_TAGS = 'FETCH_COMPANY_TAGS';
export const CREATE_ITEM_TAG_LINKS = 'CREATE_ITEM_TAG_LINKS';
